import {StateManager} from "./StateManager.js"
import { Timer } from 'three/addons/misc/Timer.js';

const state = new StateManager();

const timer = new Timer();

function Animate(time){

    timer.update(time);

    let deltaTime = timer.getDelta();

    state.Animate(deltaTime);

    requestAnimationFrame(Animate);
}

requestAnimationFrame(Animate);